import logo from '../../assets/K.svg';
const Logo = () => {
  return ( <img alt="img" src={logo} width='30'/> );
}

export default Logo;